import { Accordion, AccordionSummary, Divider, TextField } from '@mui/material';
import { Box } from '@mui/system';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';
import { theme } from 'theme/theme';

export const RatesDetailsContainer = styled(Box)`
  margin: 1.25rem auto 0 auto;
  display: grid;
  grid-template-columns: minmax(min-content, 280px) minmax(min-content, 1200px);
  gap: 0px 48px;
`;

export const RatesTabsContainer = styled(Box)`
  grid-column: 1/-1;
  border-bottom: 1px solid ${theme.palette.divider};
  margin: auto 1rem;
`;

export const RatesDetailsWrapper = styled(Box)`
  width: 100%;
  margin: auto;
  margin-top: 0;
  padding-right: 1rem;
  padding-bottom: 2rem;
`;

export const Title = styled.h1`
  text-align: left;
  font-family: sans-serif;
  font-size: 1.35rem;
  line-height: 1.1;
  font-weight: 700;
  padding-top: 1.5rem;
  padding-bottom: 0.75rem;
`;

export const Subtitle = styled.h1`
  text-align: left;
  font-family: sans-serif;
  font-size: 1.1rem;
  line-height: 1.1;
  font-weight: 500;
  display: block;
`;

export const List = styled.ul`
  margin-right: 'auto';
`;

export const ListRow = styled.li`
  display: flex;
  align-items: start;
  margin-bottom: 0.4rem;
  min-height: 31px;
`;

export const ListRowTitle = styled.div`
  width: 40%;
  font-weight: 600;
  text-align: right;
  margin-right: 12px;
`;

export const ListRowData = styled.div`
  max-width: 300px;
  text-align: left;
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin-bottom: 1rem;
`;

export const Table = styled.table`
  width: 100%;
  margin: auto;
`;

export const TableRow = styled.tr<{
  fontWeight?: string;
  selected?: boolean;
  divider?: boolean;
}>`
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '')};
  background-color: ${(props) =>
    props.selected ? `${COLORS.GRAY_1}` : 'white'};
  border-bottom: 1px solid lightgray;
  border-top: ${(props) => (props.divider ? `3px solid ${COLORS.GRAY_2}` : '')};
`;

export const PopperOption = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
    background-color: gray;
    color: white;
  }

  &:first-of-type {
    border-top-left-radius: 5px;
  }
`;

export const DetailsDivider = styled(Divider)`
  margin-bottom: 0.4rem;
`;

export const StyledAccordion = styled(Accordion)`
  &.Mui-expanded {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  margin-bottom: 1rem;
`;

export const IconLeftAccordionSummary = styled(AccordionSummary)`
  flex-direction: row-reverse;
  font-size: 1.075rem;
  & .MuiAccordionSummary-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 30px;
  }
`;

type InputPadding = 'dense' | 'normal';
export const Input = styled(TextField)<{ padding?: InputPadding }>`
  && {
    width: 230px;
    && input {
      ${({ padding }) =>
        padding === 'dense' &&
        `
    padding: 3px 8px;
  `}
    }
  }
`;

export const ListRowDataInnerList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
